import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BellRing, Send, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reminders } from "@/lib/api";

export default function RemindersPage() {
  const [data, setData] = useState({ count: 0, items: [] });

  const load = async () => {
    try { setData(await Reminders.pending()); }
    catch { toast.error("Falha ao carregar lembretes"); }
  };
  useEffect(() => { load(); }, []);

  const send = async (id) => {
    try {
      const r = await Reminders.send(id);
      toast.success(`Lembrete enviado para ${r.to}${r.mocked ? " (simulado)" : ""}`);
      load();
    } catch { toast.error("Falha ao enviar"); }
  };

  return (
    <div className="max-w-5xl mx-auto space-y-6" data-testid="reminders-page">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-sky-400 font-semibold">Comunicação</div>
        <h1 className="font-display text-4xl text-slate-50 mt-2">Lembretes 24h</h1>
        <p className="text-slate-400 text-sm mt-1">
          Lista de sessões agendadas para as próximas 24 horas. O envio real de email está <span className="text-amber-300 font-mono">MOCKED</span>
          — basta ligar SendGrid/Resend para ativar.
        </p>
      </div>

      <div className="rounded-2xl border border-slate-800 bg-slate-900/40">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-800">
          <div className="flex items-center gap-3">
            <BellRing className="w-5 h-5 text-sky-400" strokeWidth={1.5} />
            <div>
              <div className="text-slate-100 font-medium">Fila de lembretes</div>
              <div className="text-xs text-slate-500">{data.count} pendentes</div>
            </div>
          </div>
          <Button variant="outline" className="rounded-full border-slate-800 text-slate-300" onClick={load} data-testid="reminders-refresh-btn">Atualizar</Button>
        </div>
        {data.items.length === 0 ? (
          <div className="px-6 py-16 text-center text-slate-500">
            <CheckCircle2 className="w-8 h-8 mx-auto mb-3 text-emerald-400" />
            Sem lembretes para enviar nas próximas 24 horas.
          </div>
        ) : (
          <div className="divide-y divide-slate-800">
            {data.items.map((it) => (
              <div key={it.id} data-testid={`reminder-${it.id}`} className="flex items-center justify-between px-6 py-4">
                <div>
                  <div className="text-slate-100 font-medium">{it.patient_name}</div>
                  <div className="text-xs text-slate-500">
                    {new Date(it.scheduled_at).toLocaleString("pt-PT")} · Sessão {it.session_number || "—"}
                  </div>
                </div>
                <Button data-testid={`send-reminder-${it.id}`} onClick={() => send(it.id)} className="rounded-full bg-emerald-500 hover:bg-emerald-400 text-slate-950 glow-emerald">
                  <Send className="w-4 h-4 mr-2" /> Enviar
                </Button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
